import * as React from 'react';
import {useEffect} from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from "../../../core/button/button";
import Typography from '@mui/material/Typography';
import "./desktopstepper.scss";
import {Banner} from "../../../modals/types/banner";
import {useNavigate} from "react-router-dom";

const steps = ['هدف تبلیغات', 'بودجه', 'پیشنهاد ما', 'رسانه ها', 'پرداخت'];

interface IDesktopStepper {
    elements: JSX.Element[];
    sideElements: Banner[];
    setImage: React.Dispatch<React.SetStateAction<string>>;
    setTitle: React.Dispatch<React.SetStateAction<string>>;
    setBody: React.Dispatch<React.SetStateAction<string>>;
}

export default function DesktopStepper({elements, sideElements, setImage, setTitle, setBody}: IDesktopStepper) {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const navigte = useNavigate();

    const handleNext = () => {
        let newSkipped = skipped;

        const newActiveStep = activeStep + 1;
        if (newActiveStep >= steps.length) {
            return
        }

        setActiveStep(newActiveStep);
        setSkipped(newSkipped);
        setImage(sideElements[newActiveStep].image);
        setTitle(sideElements[newActiveStep].title);
        setBody(sideElements[newActiveStep].body);
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    const handleBack = () => {
        const newActiveStep = activeStep - 1;
        if (newActiveStep < 0) {
            navigte('/');
            return
        }
        setActiveStep(newActiveStep);
        setImage(sideElements[newActiveStep].image);
        setTitle(sideElements[newActiveStep].title);
        setBody(sideElements[newActiveStep].body);
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    useEffect(() => {
        setImage(sideElements[0].image);
        setTitle(sideElements[0].title);
        setBody(sideElements[0].body);
    }, [])

    return (
        <div className="Desktop-Stepper">
            <Box sx={{width: '100%'}}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label) => {
                        const stepProps: { completed?: boolean } = {};
                        const labelProps: {
                            optional?: React.ReactNode;
                        } = {};
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>&nbsp;{label}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>

                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <div className="container Elements-Box">
                            <Typography sx={{mt: 2, mb: 1}}>{elements[activeStep]}</Typography>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                gap: '20px',
                                pt: 15
                            }}>
                                <Button
                                    action={handleBack}
                                    responsive={false}
                                    type={"primary-light"}>
                                    {activeStep === 0 ? "→ بازگشت به پنل" : activeStep === 4 ? "ویرایش اطلاعات" : "→ مرحله قبل"}
                                </Button>
                                <Button action={handleNext} responsive={false} type={"primary"}>
                                    {activeStep === steps.length - 1 ? 'پرداخت' : 'تایید و ادامه ←'}
                                </Button>
                            </Box>
                        </div>
                    </React.Fragment>
                )}
            </Box>
        </div>
    );
}